/**
 * Contacts that must not reach Uplift or Pipedrive.
 * Emails are matched case-insensitively. Phones are matched on digits,
 * including a leading country code (the last 10 digits).
 */
export const SPAM_LIST = [
  'nhig234@gmail.com',
  '7787890798',
  'test1@test.com',
  'test2@test.com',
];

export const UPLIFT_SPAM_BLOCKED_EVENT = 'hera:uplift-spam-blocked';

export const UPLIFT_SPAM_MESSAGE =
  'Your email or phone number has been marked as spam.';

function digits(value: string): string {
  return value.replace(/\D/g, '');
}

const spamEmails = new Set(
  SPAM_LIST.filter((entry) => entry.includes('@')).map((entry) =>
    entry.trim().toLowerCase()
  )
);

const spamPhones = SPAM_LIST.filter((entry) => !entry.includes('@'))
  .map(digits)
  .filter(Boolean);

function phoneMatches(phone: string): boolean {
  const value = digits(phone);
  if (!value) return false;

  return spamPhones.some((entry) => {
    if (value === entry) return true;
    if (value.length >= 10 && entry.length >= 10) {
      return value.slice(-10) === entry.slice(-10);
    }
    return false;
  });
}

export function isSpamContact(email?: string, phone?: string): boolean {
  if (email && spamEmails.has(email.trim().toLowerCase())) return true;
  if (phone && phoneMatches(phone)) return true;
  return false;
}
